<template>
    <v-menu top close-on-content-click>
        <template v-slot:activator="{ props }">
            <v-btn class="white--text my-2" color="primary" depressed v-bind="props">export<v-icon right>mdi-export</v-icon></v-btn>
        </template>

        <v-list v-model="selectedExportType" color="primary">
            <v-list-item>
                <JsonExcel
                    :data="items"
                    :fields="reportJsonHeaders"
                    :name="filename + '.xls'"
                    :header="title"
                    :footer="footer"
                >
                    <v-list-item-title class="exportLink">Excel</v-list-item-title>
                </JsonExcel>
            </v-list-item>
            <v-list-item @click="exportPdf">
                <v-list-item-title>PDF</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<style>
    div.v-list-item-title.exportLink {
        cursor: pointer;
    }
</style>

<script>
    import JsonExcel from "vue-json-excel3";
    import { jsPDF } from 'jspdf';
    import autoTable from 'jspdf-autotable';

    export default {
        components: { JsonExcel },
		props: {
			items: { type: Array, required: true },
			title: { type: String, required: true },
			footer: { type: String, required: false, default: "" },
			filename: { type: String, required: true },
			headers: { type: Array, required: true }, // IDataTableHeader[]
		},
        data: () => ({
            reportRan: '',
            exportTypeList: ['Excel', 'PDF'],
            selectedExportType: null,
            loading: false,
        }),
        methods: {
            exportPdf() {
                const doc = new jsPDF({ orientation: "landscape" });
                doc.text(this.title, 10, 15);

                autoTable(doc, {
                    startY: 25,
                    columns: this.reportPdfHeaders,
                    body: this.items
                });
                if (this.footer) doc.text(this.footer, 1, 1);
                doc.save(`${this.filename}.pdf`);
            }
        },
		computed: {
            reportPdfHeaders() {
                return this.headers.map(x => { return { header: x.title, dataKey: x.key } });
            },
            reportJsonHeaders() {
                var jsonObj = {};
                this.headers.forEach(h => jsonObj[h.title] = h.key);
                return jsonObj;
            },
		},
    }
</script>
